import { Component } from '@angular/core';
import { AbstractComponent } from '../abstract-component';

@Component({
    selector: 'app-right',
    imports: [],
    templateUrl: './right.component.html',
    styleUrl: './right.component.css'
})
export class RightComponent extends AbstractComponent {

}
